var map = {
	"./OPENED_RECORD.svg": 96706,
	"./SETTING.svg": 56281,
	"./ic_authority.svg": 23150,
	"./ic_edit.svg": 19820,
	"./icon_add.svg": 67238,
	"./icon_carret.svg": 62983,
	"./icon_close.svg": 6313,
	"./icon_collapse.svg": 75571,
	"./icon_delete.svg": 97609,
	"./icon_detail.svg": 21147,
	"./icon_edit.svg": 83263,
	"./icon_exit.svg": 57974,
	"./icon_exit_fullscreen.svg": 89752,
	"./icon_fullscreen.svg": 4116,
	"./icon_refresh.svg": 67313,
	"./login_by_account.svg": 7382,
	"./login_by_wechat.svg": 93865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;